/* eslint-disable no-useless-escape, no-use-before-define, no-underscore-dangle, no-cond-assign */

// NOTE: This is a duplicate of player-modern's detect.js code.
// Please ensure that bug fixes get added in both places.
const na = navigator.userAgent;

// ua regexes taken from http://code.jquery.com/jquery-1.6.4.js
const rwebkit = /(webkit)[ \/]([^\s]+)/i;
const ropera = /OPR\/([^\s]+)/i;
const rmsie = /(msie) ([^\s;]+)/i;
const rtrident = /(trident)\/\s*([^;]+)/i;
const redge = /(edge)\/(\d+(?:\.\d+)?)/i;
const rmozilla = /(mozilla)(?:.*? rv:([^\s\)]+))?/i;

// special platform regexes
const randroid = /(android) ([^;]+)/i;
const riphone = /(iphone)/i;
const ripad = /(ipad)/i;
const rwinphone = /(Windows Phone OS (\d+(?:\.\d+)?))/;
const rios = /OS (\d+)_(\d+)/i;
const rps3 = /(playstation 3)/i;
const rblackberry = /BlackBerry|BB10/i;
const rfirefox = /(firefox)/i;
const rgearvr = /Mobile VR/i;

const browser = () => (browserMatch()[1] || 'webkit').toLowerCase();

const browserVersion = () => browserMatch()[2];

const browserMatch = () => {
  let match;
  if ((match = na.match(rwebkit))) {
    return match;
  }
  if ((match = na.match(ropera))) {
    return match;
  }
  if ((match = na.match(rmsie))) {
    if (document.documentMode != null) {
      match[2] = document.documentMode;
    }
    return match;
  }
  if ((match = na.match(rmozilla))) {
    return match;
  }
  return [];
};

// return false if not android, version info if android
const android = () => {
  const matches = na.match(randroid);
  if (matches == null) {
    return false;
  }
  return { version: matches[2] };
};

const oldandroid = () => android() && parseFloat(android().version) < 4.1;

const iphone = () => riphone.test(na);

const touchScreen = () => iosVersion() > 0 || android();

const blackberry = () => rblackberry.test(na);

const retina = () => window.devicePixelRatio != null && window.devicePixelRatio > 1;

const ipad = () => ripad.test(na);

const safari = () => rwebkit.test(na) && !/chrome/i.test(na) && !ipad() && !iphone();

const amazonSilk = () => {
  if (/Silk/.test(na)) {
    return { version: silkVersion() };
  }

  return false;
};

const chrome = () => {
  if (/Chrome/.test(na) && /Google Inc/.test(navigator.vendor)) {
    return { version: chromeVersion() };
  }
  return false;
};

const silkVersion = () => {
  const match = na.match(/\bSilk\/([^\s]+)/);
  return match && match[1];
};

const chromeVersion = () => {
  const match = na.match(/\bChrome\/([^\s]+)/);
  return match && match[1];
};

const opera = () => ropera.test(na);

const iosVersion = () => {
  const match = na.match(rios);
  if (match != null) {
    return parseFloat(`${match[1]}.${match[2]}`);
  }
  return 0;
};

const windowsPhone = () => rwinphone.test(na);

const ps3 = () => rps3.test(na);

const trident = () => rtrident.test(na);

const edge = () => redge.test(na);

const firefox = () => rfirefox.test(na);

const gearvr = () => rgearvr.test(na);

const windows = () => /win/i.test(navigator.platform);

const mac = () => /mac/i.test(navigator.platform);

const linux = () => /linux/i.test(navigator.platform);

// modified slightly from http://www.modernizr.com/downloads/modernizr-2.0.6.js
const html5Video = () => {
  const elem = document.createElement('video');
  let result = false;

  // IE9 Running on Windows Server SKU can cause an exception to be thrown, bug #224
  try {
    if (elem.canPlayType) {
      result = {};
      // Workaround required for IE9, which doesn't report video support without audio codec specified.
      // bug 599718 @ msft connect
      const h264 = 'video/mp4; codecs="avc1.42E01E';
      result.h264 = !!elem.canPlayType(`${h264}"`) || !!elem.canPlayType(`${h264}, mp4a.40.2"`);
      result.webm = !!elem.canPlayType('video/webm; codecs="vp9, vorbis"');
      result.nativeHls = !!elem.canPlayType('application/vnd.apple.mpegURL');
    }
  } catch (e) {
    result = { ogg: false, h264: false, webm: false, nativeHls: false };
  }
  return result;
};

const mediaSource = () => {
  const h264 = 'video/mp4; codecs="avc1.42E01E';
  return window.MediaSource && window.MediaSource.isTypeSupported(`${h264}, mp4a.40.2"`);
};

// We check !trident because IEMobile/IE11+ masquerades as an iphone,
// but doesn't actually support HLS playback.
const nativeHls = () => (iphone() || ipad() || safari()) && !trident() && html5Video().nativeHls;

const localStorage = () => {
  try {
    return 'localStorage' in window && window.localStorage != null;
  } catch (e) {
    return false;
  }
};

const json = () => !!(window.JSON && typeof JSON.parse === 'function');

const backgroundSize = () => {
  const testEl = document.createElement('div');
  return (
    testEl.style.backgroundSize === '' ||
    testEl.style.webkitBackgroundSize === '' ||
    testEl.style.mozBackgroundSize === '' ||
    testEl.style.oBackgroundSize === ''
  );
};

const fullscreenEnabled = () =>
  document.fullscreenEnabled ||
  document.mozFullScreenEnabled ||
  document.webkitFullscreenEnabled ||
  document.msFullscreenEnabled;

const browserPrefixes = ['WebKit', 'Moz', 'O', 'Ms', ''];
const mutationObserver = () => {
  for (let i = 0; i < browserPrefixes.length; i += 1) {
    const prefix = browserPrefixes[i];
    const prop = `${prefix}MutationObserver`;
    if (window[prop]) {
      return prop;
    }
  }
  return null;
};

const vulcanSupport = () =>
  !!(
    !iphone() &&
    !ipad() &&
    !android() &&
    !blackberry() &&
    (/webkit|mozilla/.test(browser()) || (browser() === 'msie' && browserVersion() >= 11)) &&
    html5Video().h264 &&
    Object.defineProperties
  );

// This should return browsers that _can_ autoplay with sound, even if they
// don't allow it all the time. If autoplaying with sound fails, it'll fall
// back to silent autoplay.
const supportsAutoPlayWithSound = () => {
  if (chrome() || firefox() || edge() || trident()) {
    return 'probably';
  }
  if (safari()) {
    return 'maybe';
  }
  return false;
};

let _passiveSupported;
const passiveSupported = () => {
  if (_passiveSupported != null) {
    return _passiveSupported;
  }
  try {
    const options = Object.defineProperty({}, 'passive', {
      // eslint-disable-next-line getter-return
      get() {
        _passiveSupported = true;
      },
    });

    window.addEventListener('test', null, options);
  } catch (err) {
    _passiveSupported = false;
  }
  return _passiveSupported;
};

const callingPlayRequiresEventContext = () => iosVersion() > 0 || android() || safari();

let _detectCache = null;
export const cachedDetect = () => {
  if (_detectCache) {
    // Allow this to be cached globally so it's not executed once every time
    // it's imported.
    return _detectCache;
  }

  _detectCache = uncachedDetect();
  return _detectCache;
};

const hoverIsNatural = () => {
  // The (hover: hover) query matches when two conditions are met:
  //
  // 1. hover is supported
  // 2. hover is easy to access for the user based on their primary input device
  //
  // So for example, when the user’s primary input is touch, this returns false
  // even though hover interactions are technically supported.
  //
  // If matchMedia is unsupported or the hover query is unsupported, we fall
  // back on returning the heuristic check for iOS or Android. If it is true,
  // we assume hover is not natural. This can produce false negatives and false
  // positives, but most agents support the hover query.
  //
  // This is an alternative to using touchScreen() when deciding whether to
  // attach enter/leave mouse event handlers based on hover capability.

  try {
    const mediaQueryList = matchMedia('(hover:hover)');

    if (mediaQueryList.media !== 'not all') {
      return mediaQueryList.matches;
    }
  } catch (err) {
    // feature detection: swallow errors.
  }

  return !touchScreen();
};

const uncachedDetect = () => {
  const result = {
    amazonSilk: amazonSilk(),
    browser: {
      version: browserVersion(),
      quirks: browser() === 'msie' && document.compatMode === 'BackCompat',
      old: browser() === 'msie' && (document.compatMode === 'BackCompat' || browserVersion() < 7),
      ltie8: browser() === 'msie' && (document.compatMode === 'BackCompat' || browserVersion() < 8),
    },
    trident: trident(),
    edge: edge(),
    firefox: firefox(),
    gearvr: gearvr(),
    android: android(),
    oldandroid: oldandroid(),
    iphone: iphone(),
    ipad: ipad(),
    blackberry: blackberry(),
    safari: safari(),
    chrome: chrome(),
    opera: opera(),
    winphone: { version: windowsPhone()[2] },
    ios: { version: iosVersion() },
    windows: windows(),
    mac: mac(),
    linux: linux(),
    retina: retina(),
    hoverIsNatural: hoverIsNatural(),
    touchScreen: touchScreen(),
    ps3: ps3(),
    video: html5Video(),
    mediaSource: mediaSource(),
    nativeHls: nativeHls(),
    localstorage: localStorage(),
    json: json(),
    backgroundSize: backgroundSize(),
    fullscreenEnabled: fullscreenEnabled(),
    vulcanSupport: vulcanSupport(),
    mutationObserver: mutationObserver(),
    autoPlayWithSound: supportsAutoPlayWithSound(),
    callingPlayRequiresEventContext: callingPlayRequiresEventContext(),
    passiveSupported: passiveSupported(),
  };

  result.browser[browser()] = true;

  return result;
};
